import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, renderList as _renderList } from "vue"

const _hoisted_1 = { class: "items-view" }
const _hoisted_2 = { class: "items-view__header" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "items-view__ex" }, null, -1)
const _hoisted_4 = {
  key: 0,
  class: "items-view__body"
}
const _hoisted_5 = {
  key: 1,
  class: "items-view__empty"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SortDropdown = _resolveComponent("SortDropdown")!
  const _component_NButton = _resolveComponent("NButton")!
  const _component_CameraShotAttach = _resolveComponent("CameraShotAttach")!
  const _component_ParticipantItem = _resolveComponent("ParticipantItem")!
  const _component_ObjectItem = _resolveComponent("ObjectItem")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.sortTypes && _ctx.items.length)
        ? (_openBlock(), _createBlock(_component_SortDropdown, {
            key: 0,
            items: _ctx.sortTypes,
            modelValue: _ctx.module.filter.current.ordering,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.module.filter.current.ordering) = $event))
          }, null, 8, ["items", "modelValue"]))
        : _createCommentVNode("", true),
      _hoisted_3,
      (_ctx.uploadFeature && _ctx.modelAcl.add)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createVNode(_component_NButton, {
              icon: "upload",
              type: "secondary",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('action', 'upload-file')))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('cards.upload_photo', 'f')), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_CameraShotAttach, { onAttach: _ctx.attachHandler }, null, 8, ["onAttach"])
          ], 64))
        : _createCommentVNode("", true)
    ]),
    (_ctx.items.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          (_ctx.participants)
            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.items, (item) => {
                return (_openBlock(), _createBlock(_component_ParticipantItem, {
                  key: item.id,
                  item: item,
                  "show-fullframe": true,
                  "show-case": true,
                  onClick: ($event: any) => (_ctx.participantClickHandler(item))
                }, null, 8, ["item", "onClick"]))
              }), 128))
            : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.items, (item) => {
                return (_openBlock(), _createBlock(_component_ObjectItem, {
                  key: item.id,
                  item: item,
                  acl: _ctx.modelAcl,
                  onAction: _cache[2] || (_cache[2] = (v, p) => _ctx.$emit('action', v, p))
                }, null, 8, ["item", "acl"]))
              }), 128))
        ]))
      : (!_ctx.module.loading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_ctx.$t('common.no_data', 'f')), 1))
        : _createCommentVNode("", true)
  ]))
}